import D, { useCallback as se, useState as qe, useEffect as pe, useRef as Ze, useLayoutEffect as Ut } from "react";
var Ee = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Te = { exports: {} }, ae = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var He;
function zt() {
  if (He)
    return ae;
  He = 1;
  var u = D, l = Symbol.for("react.element"), s = Symbol.for("react.fragment"), h = Object.prototype.hasOwnProperty, E = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function P(w, t, n) {
    var r, o = {}, a = null, d = null;
    n !== void 0 && (a = "" + n), t.key !== void 0 && (a = "" + t.key), t.ref !== void 0 && (d = t.ref);
    for (r in t)
      h.call(t, r) && !g.hasOwnProperty(r) && (o[r] = t[r]);
    if (w && w.defaultProps)
      for (r in t = w.defaultProps, t)
        o[r] === void 0 && (o[r] = t[r]);
    return { $$typeof: l, type: w, key: a, ref: d, props: o, _owner: E.current };
  }
  return ae.Fragment = s, ae.jsx = P, ae.jsxs = P, ae;
}
var ie = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ge;
function $t() {
  return Ge || (Ge = 1, process.env.NODE_ENV !== "production" && function() {
    var u = D, l = Symbol.for("react.element"), s = Symbol.for("react.portal"), h = Symbol.for("react.fragment"), E = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), P = Symbol.for("react.provider"), w = Symbol.for("react.context"), t = Symbol.for("react.forward_ref"), n = Symbol.for("react.suspense"), r = Symbol.for("react.suspense_list"), o = Symbol.for("react.memo"), a = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), f = Symbol.iterator, p = "@@iterator";
    function v(e) {
      if (e === null || typeof e != "object")
        return null;
      var i = f && e[f] || e[p];
      return typeof i == "function" ? i : null;
    }
    var I = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(e) {
      {
        for (var i = arguments.length, c = new Array(i > 1 ? i - 1 : 0), m = 1; m < i; m++)
          c[m - 1] = arguments[m];
        R("error", e, c);
      }
    }
    function R(e, i, c) {
      {
        var m = I.ReactDebugCurrentFrame, M = m.getStackAddendum();
        M !== "" && (i += "%s", c = c.concat([M]));
        var O = c.map(function(_) {
          return String(_);
        });
        O.unshift("Warning: " + i), Function.prototype.apply.call(console[e], console, O);
      }
    }
    var S = !1, A = !1, j = !1, k = !1, F = !1, G;
    G = Symbol.for("react.module.reference");
    function q(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === h || e === g || F || e === E || e === n || e === r || k || e === d || S || A || j || typeof e == "object" && e !== null && (e.$$typeof === a || e.$$typeof === o || e.$$typeof === P || e.$$typeof === w || e.$$typeof === t || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === G || e.getModuleId !== void 0));
    }
    function B(e, i, c) {
      var m = e.displayName;
      if (m)
        return m;
      var M = i.displayName || i.name || "";
      return M !== "" ? c + "(" + M + ")" : c;
    }
    function le(e) {
      return e.displayName || "Context";
    }
    function Y(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case h:
          return "Fragment";
        case s:
          return "Portal";
        case g:
          return "Profiler";
        case E:
          return "StrictMode";
        case n:
          return "Suspense";
        case r:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case w:
            var i = e;
            return le(i) + ".Consumer";
          case P:
            var c = e;
            return le(c._context) + ".Provider";
          case t:
            return B(e, e.render, "ForwardRef");
          case o:
            var m = e.displayName || null;
            return m !== null ? m : Y(e.type) || "Memo";
          case a: {
            var M = e, O = M._payload, _ = M._init;
            try {
              return Y(_(O));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var x = Object.assign, U = 0, Z, Q, ee, te, re, ue, ce;
    function fe() {
    }
    fe.__reactDisabledLog = !0;
    function Re() {
      {
        if (U === 0) {
          Z = console.log, Q = console.info, ee = console.warn, te = console.error, re = console.group, ue = console.groupCollapsed, ce = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: fe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        U++;
      }
    }
    function ht() {
      {
        if (U--, U === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: x({}, e, {
              value: Z
            }),
            info: x({}, e, {
              value: Q
            }),
            warn: x({}, e, {
              value: ee
            }),
            error: x({}, e, {
              value: te
            }),
            group: x({}, e, {
              value: re
            }),
            groupCollapsed: x({}, e, {
              value: ue
            }),
            groupEnd: x({}, e, {
              value: ce
            })
          });
        }
        U < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = I.ReactCurrentDispatcher, Ce;
    function de(e, i, c) {
      {
        if (Ce === void 0)
          try {
            throw Error();
          } catch (M) {
            var m = M.stack.trim().match(/\n( *(at )?)/);
            Ce = m && m[1] || "";
          }
        return `
` + Ce + e;
      }
    }
    var ye = !1, he;
    {
      var gt = typeof WeakMap == "function" ? WeakMap : Map;
      he = new gt();
    }
    function Ne(e, i) {
      if (!e || ye)
        return "";
      {
        var c = he.get(e);
        if (c !== void 0)
          return c;
      }
      var m;
      ye = !0;
      var M = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var O;
      O = we.current, we.current = null, Re();
      try {
        if (i) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch ($) {
              m = $;
            }
            Reflect.construct(e, [], _);
          } else {
            try {
              _.call();
            } catch ($) {
              m = $;
            }
            e.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch ($) {
            m = $;
          }
          e();
        }
      } catch ($) {
        if ($ && m && typeof $.stack == "string") {
          for (var b = $.stack.split(`
`), z = m.stack.split(`
`), N = b.length - 1, L = z.length - 1; N >= 1 && L >= 0 && b[N] !== z[L]; )
            L--;
          for (; N >= 1 && L >= 0; N--, L--)
            if (b[N] !== z[L]) {
              if (N !== 1 || L !== 1)
                do
                  if (N--, L--, L < 0 || b[N] !== z[L]) {
                    var W = `
` + b[N].replace(" at new ", " at ");
                    return e.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", e.displayName)), typeof e == "function" && he.set(e, W), W;
                  }
                while (N >= 1 && L >= 0);
              break;
            }
        }
      } finally {
        ye = !1, we.current = O, ht(), Error.prepareStackTrace = M;
      }
      var X = e ? e.displayName || e.name : "", V = X ? de(X) : "";
      return typeof e == "function" && he.set(e, V), V;
    }
    function vt(e, i, c) {
      return Ne(e, !1);
    }
    function Et(e) {
      var i = e.prototype;
      return !!(i && i.isReactComponent);
    }
    function ge(e, i, c) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Ne(e, Et(e));
      if (typeof e == "string")
        return de(e);
      switch (e) {
        case n:
          return de("Suspense");
        case r:
          return de("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case t:
            return vt(e.render);
          case o:
            return ge(e.type, i, c);
          case a: {
            var m = e, M = m._payload, O = m._init;
            try {
              return ge(O(M), i, c);
            } catch {
            }
          }
        }
      return "";
    }
    var ne = Object.prototype.hasOwnProperty, De = {}, Le = I.ReactDebugCurrentFrame;
    function ve(e) {
      if (e) {
        var i = e._owner, c = ge(e.type, e._source, i ? i.type : null);
        Le.setExtraStackFrame(c);
      } else
        Le.setExtraStackFrame(null);
    }
    function mt(e, i, c, m, M) {
      {
        var O = Function.call.bind(ne);
        for (var _ in e)
          if (O(e, _)) {
            var b = void 0;
            try {
              if (typeof e[_] != "function") {
                var z = Error((m || "React class") + ": " + c + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw z.name = "Invariant Violation", z;
              }
              b = e[_](i, _, m, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              b = N;
            }
            b && !(b instanceof Error) && (ve(M), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", c, _, typeof b), ve(null)), b instanceof Error && !(b.message in De) && (De[b.message] = !0, ve(M), C("Failed %s type: %s", c, b.message), ve(null));
          }
      }
    }
    var pt = Array.isArray;
    function be(e) {
      return pt(e);
    }
    function Rt(e) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, c = i && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return c;
      }
    }
    function wt(e) {
      try {
        return je(e), !1;
      } catch {
        return !0;
      }
    }
    function je(e) {
      return "" + e;
    }
    function ke(e) {
      if (wt(e))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rt(e)), je(e);
    }
    var oe = I.ReactCurrentOwner, Ct = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, Ue, Se;
    Se = {};
    function yt(e) {
      if (ne.call(e, "ref")) {
        var i = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function bt(e) {
      if (ne.call(e, "key")) {
        var i = Object.getOwnPropertyDescriptor(e, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function St(e, i) {
      if (typeof e.ref == "string" && oe.current && i && oe.current.stateNode !== i) {
        var c = Y(oe.current.type);
        Se[c] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(oe.current.type), e.ref), Se[c] = !0);
      }
    }
    function Pt(e, i) {
      {
        var c = function() {
          xe || (xe = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        c.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: c,
          configurable: !0
        });
      }
    }
    function _t(e, i) {
      {
        var c = function() {
          Ue || (Ue = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        c.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: c,
          configurable: !0
        });
      }
    }
    var Mt = function(e, i, c, m, M, O, _) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: l,
        // Built-in properties that belong on the element
        type: e,
        key: i,
        ref: c,
        props: _,
        // Record the component responsible for creating this element.
        _owner: O
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Ot(e, i, c, m, M) {
      {
        var O, _ = {}, b = null, z = null;
        c !== void 0 && (ke(c), b = "" + c), bt(i) && (ke(i.key), b = "" + i.key), yt(i) && (z = i.ref, St(i, M));
        for (O in i)
          ne.call(i, O) && !Ct.hasOwnProperty(O) && (_[O] = i[O]);
        if (e && e.defaultProps) {
          var N = e.defaultProps;
          for (O in N)
            _[O] === void 0 && (_[O] = N[O]);
        }
        if (b || z) {
          var L = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          b && Pt(_, L), z && _t(_, L);
        }
        return Mt(e, b, z, M, m, oe.current, _);
      }
    }
    var Pe = I.ReactCurrentOwner, ze = I.ReactDebugCurrentFrame;
    function K(e) {
      if (e) {
        var i = e._owner, c = ge(e.type, e._source, i ? i.type : null);
        ze.setExtraStackFrame(c);
      } else
        ze.setExtraStackFrame(null);
    }
    var _e;
    _e = !1;
    function Me(e) {
      return typeof e == "object" && e !== null && e.$$typeof === l;
    }
    function $e() {
      {
        if (Pe.current) {
          var e = Y(Pe.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function At(e) {
      {
        if (e !== void 0) {
          var i = e.fileName.replace(/^.*[\\\/]/, ""), c = e.lineNumber;
          return `

Check your code at ` + i + ":" + c + ".";
        }
        return "";
      }
    }
    var Be = {};
    function Tt(e) {
      {
        var i = $e();
        if (!i) {
          var c = typeof e == "string" ? e : e.displayName || e.name;
          c && (i = `

Check the top-level render call using <` + c + ">.");
        }
        return i;
      }
    }
    function Ye(e, i) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var c = Tt(i);
        if (Be[c])
          return;
        Be[c] = !0;
        var m = "";
        e && e._owner && e._owner !== Pe.current && (m = " It was passed a child from " + Y(e._owner.type) + "."), K(e), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', c, m), K(null);
      }
    }
    function We(e, i) {
      {
        if (typeof e != "object")
          return;
        if (be(e))
          for (var c = 0; c < e.length; c++) {
            var m = e[c];
            Me(m) && Ye(m, i);
          }
        else if (Me(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var M = v(e);
          if (typeof M == "function" && M !== e.entries)
            for (var O = M.call(e), _; !(_ = O.next()).done; )
              Me(_.value) && Ye(_.value, i);
        }
      }
    }
    function It(e) {
      {
        var i = e.type;
        if (i == null || typeof i == "string")
          return;
        var c;
        if (typeof i == "function")
          c = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === t || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === o))
          c = i.propTypes;
        else
          return;
        if (c) {
          var m = Y(i);
          mt(c, e.props, "prop", m, e);
        } else if (i.PropTypes !== void 0 && !_e) {
          _e = !0;
          var M = Y(i);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", M || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ft(e) {
      {
        for (var i = Object.keys(e.props), c = 0; c < i.length; c++) {
          var m = i[c];
          if (m !== "children" && m !== "key") {
            K(e), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), K(null);
            break;
          }
        }
        e.ref !== null && (K(e), C("Invalid attribute `ref` supplied to `React.Fragment`."), K(null));
      }
    }
    var Qe = {};
    function Ve(e, i, c, m, M, O) {
      {
        var _ = q(e);
        if (!_) {
          var b = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var z = At(M);
          z ? b += z : b += $e();
          var N;
          e === null ? N = "null" : be(e) ? N = "array" : e !== void 0 && e.$$typeof === l ? (N = "<" + (Y(e.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : N = typeof e, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", N, b);
        }
        var L = Ot(e, i, c, M, O);
        if (L == null)
          return L;
        if (_) {
          var W = i.children;
          if (W !== void 0)
            if (m)
              if (be(W)) {
                for (var X = 0; X < W.length; X++)
                  We(W[X], e);
                Object.freeze && Object.freeze(W);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              We(W, e);
        }
        if (ne.call(i, "key")) {
          var V = Y(e), $ = Object.keys(i).filter(function(xt) {
            return xt !== "key";
          }), Oe = $.length > 0 ? "{key: someKey, " + $.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Qe[V + Oe]) {
            var kt = $.length > 0 ? "{" + $.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Oe, V, kt, V), Qe[V + Oe] = !0;
          }
        }
        return e === h ? Ft(L) : It(L), L;
      }
    }
    function Nt(e, i, c) {
      return Ve(e, i, c, !0);
    }
    function Dt(e, i, c) {
      return Ve(e, i, c, !1);
    }
    var Lt = Dt, jt = Nt;
    ie.Fragment = h, ie.jsx = Lt, ie.jsxs = jt;
  }()), ie;
}
process.env.NODE_ENV === "production" ? Te.exports = zt() : Te.exports = $t();
var Bt = Te.exports, Yt = Object.defineProperty, me = Object.getOwnPropertySymbols, et = Object.prototype.hasOwnProperty, tt = Object.prototype.propertyIsEnumerable, Ke = (u, l, s) => l in u ? Yt(u, l, { enumerable: !0, configurable: !0, writable: !0, value: s }) : u[l] = s, Ie = (u, l) => {
  for (var s in l || (l = {}))
    et.call(l, s) && Ke(u, s, l[s]);
  if (me)
    for (var s of me(l))
      tt.call(l, s) && Ke(u, s, l[s]);
  return u;
}, Fe = (u, l) => {
  var s = {};
  for (var h in u)
    et.call(u, h) && l.indexOf(h) < 0 && (s[h] = u[h]);
  if (u != null && me)
    for (var h of me(u))
      l.indexOf(h) < 0 && tt.call(u, h) && (s[h] = u[h]);
  return s;
};
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var H;
((u) => {
  const l = class y {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    constructor(t, n, r, o) {
      if (this.version = t, this.errorCorrectionLevel = n, this.modules = [], this.isFunction = [], t < y.MIN_VERSION || t > y.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (o < -1 || o > 7)
        throw new RangeError("Mask value out of range");
      this.size = t * 4 + 17;
      let a = [];
      for (let f = 0; f < this.size; f++)
        a.push(!1);
      for (let f = 0; f < this.size; f++)
        this.modules.push(a.slice()), this.isFunction.push(a.slice());
      this.drawFunctionPatterns();
      const d = this.addEccAndInterleave(r);
      if (this.drawCodewords(d), o == -1) {
        let f = 1e9;
        for (let p = 0; p < 8; p++) {
          this.applyMask(p), this.drawFormatBits(p);
          const v = this.getPenaltyScore();
          v < f && (o = p, f = v), this.applyMask(p);
        }
      }
      E(0 <= o && o <= 7), this.mask = o, this.applyMask(o), this.drawFormatBits(o), this.isFunction = [];
    }
    /*-- Static factory functions (high level) --*/
    // Returns a QR Code representing the given Unicode text string at the given error correction level.
    // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
    // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
    // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
    // ecl argument if it can be done without increasing the version.
    static encodeText(t, n) {
      const r = u.QrSegment.makeSegments(t);
      return y.encodeSegments(r, n);
    }
    // Returns a QR Code representing the given binary data at the given error correction level.
    // This function always encodes using the binary segment mode, not any text mode. The maximum number of
    // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
    // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
    static encodeBinary(t, n) {
      const r = u.QrSegment.makeBytes(t);
      return y.encodeSegments([r], n);
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a QR Code representing the given segments with the given encoding parameters.
    // The smallest possible QR Code version within the given range is automatically
    // chosen for the output. Iff boostEcl is true, then the ECC level of the result
    // may be higher than the ecl argument if it can be done without increasing the
    // version. The mask number is either between 0 to 7 (inclusive) to force that
    // mask, or -1 to automatically choose an appropriate mask (which may be slow).
    // This function allows the user to create a custom sequence of segments that switches
    // between modes (such as alphanumeric and byte) to encode text in less space.
    // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
    static encodeSegments(t, n, r = 1, o = 40, a = -1, d = !0) {
      if (!(y.MIN_VERSION <= r && r <= o && o <= y.MAX_VERSION) || a < -1 || a > 7)
        throw new RangeError("Invalid value");
      let f, p;
      for (f = r; ; f++) {
        const R = y.getNumDataCodewords(f, n) * 8, S = P.getTotalBits(t, f);
        if (S <= R) {
          p = S;
          break;
        }
        if (f >= o)
          throw new RangeError("Data too long");
      }
      for (const R of [y.Ecc.MEDIUM, y.Ecc.QUARTILE, y.Ecc.HIGH])
        d && p <= y.getNumDataCodewords(f, R) * 8 && (n = R);
      let v = [];
      for (const R of t) {
        s(R.mode.modeBits, 4, v), s(R.numChars, R.mode.numCharCountBits(f), v);
        for (const S of R.getData())
          v.push(S);
      }
      E(v.length == p);
      const I = y.getNumDataCodewords(f, n) * 8;
      E(v.length <= I), s(0, Math.min(4, I - v.length), v), s(0, (8 - v.length % 8) % 8, v), E(v.length % 8 == 0);
      for (let R = 236; v.length < I; R ^= 253)
        s(R, 8, v);
      let C = [];
      for (; C.length * 8 < v.length; )
        C.push(0);
      return v.forEach((R, S) => C[S >>> 3] |= R << 7 - (S & 7)), new y(f, n, C, a);
    }
    /*-- Accessor methods --*/
    // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    getModule(t, n) {
      return 0 <= t && t < this.size && 0 <= n && n < this.size && this.modules[n][t];
    }
    // Modified to expose modules for easy access
    getModules() {
      return this.modules;
    }
    /*-- Private helper methods for constructor: Drawing function modules --*/
    // Reads this object's version field, and draws and marks all function modules.
    drawFunctionPatterns() {
      for (let r = 0; r < this.size; r++)
        this.setFunctionModule(6, r, r % 2 == 0), this.setFunctionModule(r, 6, r % 2 == 0);
      this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
      const t = this.getAlignmentPatternPositions(), n = t.length;
      for (let r = 0; r < n; r++)
        for (let o = 0; o < n; o++)
          r == 0 && o == 0 || r == 0 && o == n - 1 || r == n - 1 && o == 0 || this.drawAlignmentPattern(t[r], t[o]);
      this.drawFormatBits(0), this.drawVersion();
    }
    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
    drawFormatBits(t) {
      const n = this.errorCorrectionLevel.formatBits << 3 | t;
      let r = n;
      for (let a = 0; a < 10; a++)
        r = r << 1 ^ (r >>> 9) * 1335;
      const o = (n << 10 | r) ^ 21522;
      E(o >>> 15 == 0);
      for (let a = 0; a <= 5; a++)
        this.setFunctionModule(8, a, h(o, a));
      this.setFunctionModule(8, 7, h(o, 6)), this.setFunctionModule(8, 8, h(o, 7)), this.setFunctionModule(7, 8, h(o, 8));
      for (let a = 9; a < 15; a++)
        this.setFunctionModule(14 - a, 8, h(o, a));
      for (let a = 0; a < 8; a++)
        this.setFunctionModule(this.size - 1 - a, 8, h(o, a));
      for (let a = 8; a < 15; a++)
        this.setFunctionModule(8, this.size - 15 + a, h(o, a));
      this.setFunctionModule(8, this.size - 8, !0);
    }
    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
    drawVersion() {
      if (this.version < 7)
        return;
      let t = this.version;
      for (let r = 0; r < 12; r++)
        t = t << 1 ^ (t >>> 11) * 7973;
      const n = this.version << 12 | t;
      E(n >>> 18 == 0);
      for (let r = 0; r < 18; r++) {
        const o = h(n, r), a = this.size - 11 + r % 3, d = Math.floor(r / 3);
        this.setFunctionModule(a, d, o), this.setFunctionModule(d, a, o);
      }
    }
    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
    drawFinderPattern(t, n) {
      for (let r = -4; r <= 4; r++)
        for (let o = -4; o <= 4; o++) {
          const a = Math.max(Math.abs(o), Math.abs(r)), d = t + o, f = n + r;
          0 <= d && d < this.size && 0 <= f && f < this.size && this.setFunctionModule(d, f, a != 2 && a != 4);
        }
    }
    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
    drawAlignmentPattern(t, n) {
      for (let r = -2; r <= 2; r++)
        for (let o = -2; o <= 2; o++)
          this.setFunctionModule(t + o, n + r, Math.max(Math.abs(o), Math.abs(r)) != 1);
    }
    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
    setFunctionModule(t, n, r) {
      this.modules[n][t] = r, this.isFunction[n][t] = !0;
    }
    /*-- Private helper methods for constructor: Codewords and masking --*/
    // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
    addEccAndInterleave(t) {
      const n = this.version, r = this.errorCorrectionLevel;
      if (t.length != y.getNumDataCodewords(n, r))
        throw new RangeError("Invalid argument");
      const o = y.NUM_ERROR_CORRECTION_BLOCKS[r.ordinal][n], a = y.ECC_CODEWORDS_PER_BLOCK[r.ordinal][n], d = Math.floor(y.getNumRawDataModules(n) / 8), f = o - d % o, p = Math.floor(d / o);
      let v = [];
      const I = y.reedSolomonComputeDivisor(a);
      for (let R = 0, S = 0; R < o; R++) {
        let A = t.slice(S, S + p - a + (R < f ? 0 : 1));
        S += A.length;
        const j = y.reedSolomonComputeRemainder(A, I);
        R < f && A.push(0), v.push(A.concat(j));
      }
      let C = [];
      for (let R = 0; R < v[0].length; R++)
        v.forEach((S, A) => {
          (R != p - a || A >= f) && C.push(S[R]);
        });
      return E(C.length == d), C;
    }
    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
    drawCodewords(t) {
      if (t.length != Math.floor(y.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let n = 0;
      for (let r = this.size - 1; r >= 1; r -= 2) {
        r == 6 && (r = 5);
        for (let o = 0; o < this.size; o++)
          for (let a = 0; a < 2; a++) {
            const d = r - a, p = (r + 1 & 2) == 0 ? this.size - 1 - o : o;
            !this.isFunction[p][d] && n < t.length * 8 && (this.modules[p][d] = h(t[n >>> 3], 7 - (n & 7)), n++);
          }
      }
      E(n == t.length * 8);
    }
    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
    applyMask(t) {
      if (t < 0 || t > 7)
        throw new RangeError("Mask value out of range");
      for (let n = 0; n < this.size; n++)
        for (let r = 0; r < this.size; r++) {
          let o;
          switch (t) {
            case 0:
              o = (r + n) % 2 == 0;
              break;
            case 1:
              o = n % 2 == 0;
              break;
            case 2:
              o = r % 3 == 0;
              break;
            case 3:
              o = (r + n) % 3 == 0;
              break;
            case 4:
              o = (Math.floor(r / 3) + Math.floor(n / 2)) % 2 == 0;
              break;
            case 5:
              o = r * n % 2 + r * n % 3 == 0;
              break;
            case 6:
              o = (r * n % 2 + r * n % 3) % 2 == 0;
              break;
            case 7:
              o = ((r + n) % 2 + r * n % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          !this.isFunction[n][r] && o && (this.modules[n][r] = !this.modules[n][r]);
        }
    }
    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
    getPenaltyScore() {
      let t = 0;
      for (let a = 0; a < this.size; a++) {
        let d = !1, f = 0, p = [0, 0, 0, 0, 0, 0, 0];
        for (let v = 0; v < this.size; v++)
          this.modules[a][v] == d ? (f++, f == 5 ? t += y.PENALTY_N1 : f > 5 && t++) : (this.finderPenaltyAddHistory(f, p), d || (t += this.finderPenaltyCountPatterns(p) * y.PENALTY_N3), d = this.modules[a][v], f = 1);
        t += this.finderPenaltyTerminateAndCount(d, f, p) * y.PENALTY_N3;
      }
      for (let a = 0; a < this.size; a++) {
        let d = !1, f = 0, p = [0, 0, 0, 0, 0, 0, 0];
        for (let v = 0; v < this.size; v++)
          this.modules[v][a] == d ? (f++, f == 5 ? t += y.PENALTY_N1 : f > 5 && t++) : (this.finderPenaltyAddHistory(f, p), d || (t += this.finderPenaltyCountPatterns(p) * y.PENALTY_N3), d = this.modules[v][a], f = 1);
        t += this.finderPenaltyTerminateAndCount(d, f, p) * y.PENALTY_N3;
      }
      for (let a = 0; a < this.size - 1; a++)
        for (let d = 0; d < this.size - 1; d++) {
          const f = this.modules[a][d];
          f == this.modules[a][d + 1] && f == this.modules[a + 1][d] && f == this.modules[a + 1][d + 1] && (t += y.PENALTY_N2);
        }
      let n = 0;
      for (const a of this.modules)
        n = a.reduce((d, f) => d + (f ? 1 : 0), n);
      const r = this.size * this.size, o = Math.ceil(Math.abs(n * 20 - r * 10) / r) - 1;
      return E(0 <= o && o <= 9), t += o * y.PENALTY_N4, E(0 <= t && t <= 2568888), t;
    }
    /*-- Private helper functions --*/
    // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of integers.
    getAlignmentPatternPositions() {
      if (this.version == 1)
        return [];
      {
        const t = Math.floor(this.version / 7) + 2, n = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (t * 2 - 2)) * 2;
        let r = [6];
        for (let o = this.size - 7; r.length < t; o -= n)
          r.splice(1, 0, o);
        return r;
      }
    }
    // Returns the number of data bits that can be stored in a QR Code of the given version number, after
    // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
    // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
    static getNumRawDataModules(t) {
      if (t < y.MIN_VERSION || t > y.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let n = (16 * t + 128) * t + 64;
      if (t >= 2) {
        const r = Math.floor(t / 7) + 2;
        n -= (25 * r - 10) * r - 55, t >= 7 && (n -= 36);
      }
      return E(208 <= n && n <= 29648), n;
    }
    // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
    // QR Code of the given version number and error correction level, with remainder bits discarded.
    // This stateless pure function could be implemented as a (40*4)-cell lookup table.
    static getNumDataCodewords(t, n) {
      return Math.floor(y.getNumRawDataModules(t) / 8) - y.ECC_CODEWORDS_PER_BLOCK[n.ordinal][t] * y.NUM_ERROR_CORRECTION_BLOCKS[n.ordinal][t];
    }
    // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
    // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
    static reedSolomonComputeDivisor(t) {
      if (t < 1 || t > 255)
        throw new RangeError("Degree out of range");
      let n = [];
      for (let o = 0; o < t - 1; o++)
        n.push(0);
      n.push(1);
      let r = 1;
      for (let o = 0; o < t; o++) {
        for (let a = 0; a < n.length; a++)
          n[a] = y.reedSolomonMultiply(n[a], r), a + 1 < n.length && (n[a] ^= n[a + 1]);
        r = y.reedSolomonMultiply(r, 2);
      }
      return n;
    }
    // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
    static reedSolomonComputeRemainder(t, n) {
      let r = n.map((o) => 0);
      for (const o of t) {
        const a = o ^ r.shift();
        r.push(0), n.forEach((d, f) => r[f] ^= y.reedSolomonMultiply(d, a));
      }
      return r;
    }
    // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
    // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
    static reedSolomonMultiply(t, n) {
      if (t >>> 8 || n >>> 8)
        throw new RangeError("Byte out of range");
      let r = 0;
      for (let o = 7; o >= 0; o--)
        r = r << 1 ^ (r >>> 7) * 285, r ^= (n >>> o & 1) * t;
      return E(r >>> 8 == 0), r;
    }
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    finderPenaltyCountPatterns(t) {
      const n = t[1];
      E(n <= this.size * 3);
      const r = n > 0 && t[2] == n && t[3] == n * 3 && t[4] == n && t[5] == n;
      return (r && t[0] >= n * 4 && t[6] >= n ? 1 : 0) + (r && t[6] >= n * 4 && t[0] >= n ? 1 : 0);
    }
    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
    finderPenaltyTerminateAndCount(t, n, r) {
      return t && (this.finderPenaltyAddHistory(n, r), n = 0), n += this.size, this.finderPenaltyAddHistory(n, r), this.finderPenaltyCountPatterns(r);
    }
    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
    finderPenaltyAddHistory(t, n) {
      n[0] == 0 && (t += this.size), n.pop(), n.unshift(t);
    }
  };
  l.MIN_VERSION = 1, l.MAX_VERSION = 40, l.PENALTY_N1 = 3, l.PENALTY_N2 = 3, l.PENALTY_N3 = 40, l.PENALTY_N4 = 10, l.ECC_CODEWORDS_PER_BLOCK = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Low
    [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
    // Medium
    [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Quartile
    [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
    // High
  ], l.NUM_ERROR_CORRECTION_BLOCKS = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
    // Low
    [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
    // Medium
    [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
    // Quartile
    [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
    // High
  ], u.QrCode = l;
  function s(w, t, n) {
    if (t < 0 || t > 31 || w >>> t)
      throw new RangeError("Value out of range");
    for (let r = t - 1; r >= 0; r--)
      n.push(w >>> r & 1);
  }
  function h(w, t) {
    return (w >>> t & 1) != 0;
  }
  function E(w) {
    if (!w)
      throw new Error("Assertion error");
  }
  const g = class T {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constraint isn't checked. The given bit buffer is cloned and stored.
    constructor(t, n, r) {
      if (this.mode = t, this.numChars = n, this.bitData = r, n < 0)
        throw new RangeError("Invalid argument");
      this.bitData = r.slice();
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a segment representing the given binary data encoded in
    // byte mode. All input byte arrays are acceptable. Any text string
    // can be converted to UTF-8 bytes and encoded as a byte mode segment.
    static makeBytes(t) {
      let n = [];
      for (const r of t)
        s(r, 8, n);
      return new T(T.Mode.BYTE, t.length, n);
    }
    // Returns a segment representing the given string of decimal digits encoded in numeric mode.
    static makeNumeric(t) {
      if (!T.isNumeric(t))
        throw new RangeError("String contains non-numeric characters");
      let n = [];
      for (let r = 0; r < t.length; ) {
        const o = Math.min(t.length - r, 3);
        s(parseInt(t.substring(r, r + o), 10), o * 3 + 1, n), r += o;
      }
      return new T(T.Mode.NUMERIC, t.length, n);
    }
    // Returns a segment representing the given text string encoded in alphanumeric mode.
    // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
    // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static makeAlphanumeric(t) {
      if (!T.isAlphanumeric(t))
        throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let n = [], r;
      for (r = 0; r + 2 <= t.length; r += 2) {
        let o = T.ALPHANUMERIC_CHARSET.indexOf(t.charAt(r)) * 45;
        o += T.ALPHANUMERIC_CHARSET.indexOf(t.charAt(r + 1)), s(o, 11, n);
      }
      return r < t.length && s(T.ALPHANUMERIC_CHARSET.indexOf(t.charAt(r)), 6, n), new T(T.Mode.ALPHANUMERIC, t.length, n);
    }
    // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
    // The result may use various segment modes and switch modes to optimize the length of the bit stream.
    static makeSegments(t) {
      return t == "" ? [] : T.isNumeric(t) ? [T.makeNumeric(t)] : T.isAlphanumeric(t) ? [T.makeAlphanumeric(t)] : [T.makeBytes(T.toUtf8ByteArray(t))];
    }
    // Returns a segment representing an Extended Channel Interpretation
    // (ECI) designator with the given assignment value.
    static makeEci(t) {
      let n = [];
      if (t < 0)
        throw new RangeError("ECI assignment value out of range");
      if (t < 128)
        s(t, 8, n);
      else if (t < 16384)
        s(2, 2, n), s(t, 14, n);
      else if (t < 1e6)
        s(6, 3, n), s(t, 21, n);
      else
        throw new RangeError("ECI assignment value out of range");
      return new T(T.Mode.ECI, 0, n);
    }
    // Tests whether the given string can be encoded as a segment in numeric mode.
    // A string is encodable iff each character is in the range 0 to 9.
    static isNumeric(t) {
      return T.NUMERIC_REGEX.test(t);
    }
    // Tests whether the given string can be encoded as a segment in alphanumeric mode.
    // A string is encodable iff each character is in the following set: 0 to 9, A to Z
    // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static isAlphanumeric(t) {
      return T.ALPHANUMERIC_REGEX.test(t);
    }
    /*-- Methods --*/
    // Returns a new copy of the data bits of this segment.
    getData() {
      return this.bitData.slice();
    }
    // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
    // the given version. The result is infinity if a segment has too many characters to fit its length field.
    static getTotalBits(t, n) {
      let r = 0;
      for (const o of t) {
        const a = o.mode.numCharCountBits(n);
        if (o.numChars >= 1 << a)
          return 1 / 0;
        r += 4 + a + o.bitData.length;
      }
      return r;
    }
    // Returns a new array of bytes representing the given string encoded in UTF-8.
    static toUtf8ByteArray(t) {
      t = encodeURI(t);
      let n = [];
      for (let r = 0; r < t.length; r++)
        t.charAt(r) != "%" ? n.push(t.charCodeAt(r)) : (n.push(parseInt(t.substring(r + 1, r + 3), 16)), r += 2);
      return n;
    }
  };
  g.NUMERIC_REGEX = /^[0-9]*$/, g.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, g.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  let P = g;
  u.QrSegment = g;
})(H || (H = {}));
((u) => {
  ((l) => {
    const s = class {
      // The QR Code can tolerate about 30% erroneous codewords
      /*-- Constructor and fields --*/
      constructor(E, g) {
        this.ordinal = E, this.formatBits = g;
      }
    };
    s.LOW = new s(0, 1), s.MEDIUM = new s(1, 0), s.QUARTILE = new s(2, 3), s.HIGH = new s(3, 2), l.Ecc = s;
  })(u.QrCode || (u.QrCode = {}));
})(H || (H = {}));
((u) => {
  ((l) => {
    const s = class {
      /*-- Constructor and fields --*/
      constructor(E, g) {
        this.modeBits = E, this.numBitsCharCount = g;
      }
      /*-- Method --*/
      // (Package-private) Returns the bit width of the character count field for a segment in
      // this mode in a QR Code at the given version number. The result is in the range [0, 16].
      numCharCountBits(E) {
        return this.numBitsCharCount[Math.floor((E + 7) / 17)];
      }
    };
    s.NUMERIC = new s(1, [10, 12, 14]), s.ALPHANUMERIC = new s(2, [9, 11, 13]), s.BYTE = new s(4, [8, 16, 16]), s.KANJI = new s(8, [8, 10, 12]), s.ECI = new s(7, [0, 0, 0]), l.Mode = s;
  })(u.QrSegment || (u.QrSegment = {}));
})(H || (H = {}));
var J = H;
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var Wt = {
  L: J.QrCode.Ecc.LOW,
  M: J.QrCode.Ecc.MEDIUM,
  Q: J.QrCode.Ecc.QUARTILE,
  H: J.QrCode.Ecc.HIGH
}, rt = 128, nt = "L", ot = "#FFFFFF", at = "#000000", it = !1, st = 1, Qt = 4, Vt = 0, Ht = 0.1;
function lt(u, l = 0) {
  const s = [];
  return u.forEach(function(h, E) {
    let g = null;
    h.forEach(function(P, w) {
      if (!P && g !== null) {
        s.push(
          `M${g + l} ${E + l}h${w - g}v1H${g + l}z`
        ), g = null;
        return;
      }
      if (w === h.length - 1) {
        if (!P)
          return;
        g === null ? s.push(`M${w + l},${E + l} h1v1H${w + l}z`) : s.push(
          `M${g + l},${E + l} h${w + 1 - g}v1H${g + l}z`
        );
        return;
      }
      P && g === null && (g = w);
    });
  }), s.join("");
}
function ut(u, l) {
  return u.slice().map((s, h) => h < l.y || h >= l.y + l.h ? s : s.map((E, g) => g < l.x || g >= l.x + l.w ? E : !1));
}
function Gt(u, l, s, h) {
  if (h == null)
    return null;
  const E = u.length + s * 2, g = Math.floor(l * Ht), P = E / l, w = (h.width || g) * P, t = (h.height || g) * P, n = h.x == null ? u.length / 2 - w / 2 : h.x * P, r = h.y == null ? u.length / 2 - t / 2 : h.y * P, o = h.opacity == null ? 1 : h.opacity;
  let a = null;
  if (h.excavate) {
    let f = Math.floor(n), p = Math.floor(r), v = Math.ceil(w + n - f), I = Math.ceil(t + r - p);
    a = { x: f, y: p, w: v, h: I };
  }
  const d = h.crossOrigin;
  return { x: n, y: r, h: t, w, excavation: a, opacity: o, crossOrigin: d };
}
function Kt(u, l) {
  return l != null ? Math.max(Math.floor(l), 0) : u ? Qt : Vt;
}
function ct({
  value: u,
  level: l,
  minVersion: s,
  includeMargin: h,
  marginSize: E,
  imageSettings: g,
  size: P,
  boostLevel: w
}) {
  let t = D.useMemo(() => {
    const f = (Array.isArray(u) ? u : [u]).reduce((p, v) => (p.push(...J.QrSegment.makeSegments(v)), p), []);
    return J.QrCode.encodeSegments(
      f,
      Wt[l],
      s,
      void 0,
      void 0,
      w
    );
  }, [u, l, s, w]);
  const { cells: n, margin: r, numCells: o, calculatedImageSettings: a } = D.useMemo(() => {
    let d = t.getModules();
    const f = Kt(h, E), p = d.length + f * 2, v = Gt(
      d,
      P,
      f,
      g
    );
    return {
      cells: d,
      margin: f,
      numCells: p,
      calculatedImageSettings: v
    };
  }, [t, P, g, h, E]);
  return {
    qrcode: t,
    margin: r,
    cells: n,
    numCells: o,
    calculatedImageSettings: a
  };
}
var Xt = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch {
    return !1;
  }
  return !0;
}(), Jt = D.forwardRef(
  function(l, s) {
    const h = l, {
      value: E,
      size: g = rt,
      level: P = nt,
      bgColor: w = ot,
      fgColor: t = at,
      includeMargin: n = it,
      minVersion: r = st,
      boostLevel: o,
      marginSize: a,
      imageSettings: d
    } = h, p = Fe(h, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "marginSize",
      "imageSettings"
    ]), { style: v } = p, I = Fe(p, ["style"]), C = d == null ? void 0 : d.src, R = D.useRef(null), S = D.useRef(null), A = D.useCallback(
      (x) => {
        R.current = x, typeof s == "function" ? s(x) : s && (s.current = x);
      },
      [s]
    ), [j, k] = D.useState(!1), { margin: F, cells: G, numCells: q, calculatedImageSettings: B } = ct({
      value: E,
      level: P,
      minVersion: r,
      boostLevel: o,
      includeMargin: n,
      marginSize: a,
      imageSettings: d,
      size: g
    });
    D.useEffect(() => {
      if (R.current != null) {
        const x = R.current, U = x.getContext("2d");
        if (!U)
          return;
        let Z = G;
        const Q = S.current, ee = B != null && Q !== null && Q.complete && Q.naturalHeight !== 0 && Q.naturalWidth !== 0;
        ee && B.excavation != null && (Z = ut(
          G,
          B.excavation
        ));
        const te = window.devicePixelRatio || 1;
        x.height = x.width = g * te;
        const re = g / q * te;
        U.scale(re, re), U.fillStyle = w, U.fillRect(0, 0, q, q), U.fillStyle = t, Xt ? U.fill(new Path2D(lt(Z, F))) : G.forEach(function(ue, ce) {
          ue.forEach(function(fe, Re) {
            fe && U.fillRect(Re + F, ce + F, 1, 1);
          });
        }), B && (U.globalAlpha = B.opacity), ee && U.drawImage(
          Q,
          B.x + F,
          B.y + F,
          B.w,
          B.h
        );
      }
    }), D.useEffect(() => {
      k(!1);
    }, [C]);
    const le = Ie({ height: g, width: g }, v);
    let Y = null;
    return C != null && (Y = /* @__PURE__ */ D.createElement(
      "img",
      {
        src: C,
        key: C,
        style: { display: "none" },
        onLoad: () => {
          k(!0);
        },
        ref: S,
        crossOrigin: B == null ? void 0 : B.crossOrigin
      }
    )), /* @__PURE__ */ D.createElement(D.Fragment, null, /* @__PURE__ */ D.createElement(
      "canvas",
      Ie({
        style: le,
        height: g,
        width: g,
        ref: A,
        role: "img"
      }, I)
    ), Y);
  }
);
Jt.displayName = "QRCodeCanvas";
var ft = D.forwardRef(
  function(l, s) {
    const h = l, {
      value: E,
      size: g = rt,
      level: P = nt,
      bgColor: w = ot,
      fgColor: t = at,
      includeMargin: n = it,
      minVersion: r = st,
      boostLevel: o,
      title: a,
      marginSize: d,
      imageSettings: f
    } = h, p = Fe(h, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "title",
      "marginSize",
      "imageSettings"
    ]), { margin: v, cells: I, numCells: C, calculatedImageSettings: R } = ct({
      value: E,
      level: P,
      minVersion: r,
      boostLevel: o,
      includeMargin: n,
      marginSize: d,
      imageSettings: f,
      size: g
    });
    let S = I, A = null;
    f != null && R != null && (R.excavation != null && (S = ut(
      I,
      R.excavation
    )), A = /* @__PURE__ */ D.createElement(
      "image",
      {
        href: f.src,
        height: R.h,
        width: R.w,
        x: R.x + v,
        y: R.y + v,
        preserveAspectRatio: "none",
        opacity: R.opacity,
        crossOrigin: R.crossOrigin
      }
    ));
    const j = lt(S, v);
    return /* @__PURE__ */ D.createElement(
      "svg",
      Ie({
        height: g,
        width: g,
        viewBox: `0 0 ${C} ${C}`,
        ref: s,
        role: "img"
      }, p),
      !!a && /* @__PURE__ */ D.createElement("title", null, a),
      /* @__PURE__ */ D.createElement(
        "path",
        {
          fill: w,
          d: `M0,0 h${C}v${C}H0z`,
          shapeRendering: "crispEdges"
        }
      ),
      /* @__PURE__ */ D.createElement("path", { fill: t, d: j, shapeRendering: "crispEdges" }),
      A
    );
  }
);
ft.displayName = "QRCodeSVG";
var qt = typeof Ee == "object" && Ee && Ee.Object === Object && Ee, Zt = typeof self == "object" && self && self.Object === Object && self;
qt || Zt || Function("return this")();
var dt = typeof window < "u" ? Ut : pe;
function Xe(u, l, s, h) {
  const E = Ze(l);
  dt(() => {
    E.current = l;
  }, [l]), pe(() => {
    const g = (s == null ? void 0 : s.current) ?? window;
    if (!(g && g.addEventListener))
      return;
    const P = (w) => {
      E.current(w);
    };
    return g.addEventListener(u, P, h), () => {
      g.removeEventListener(u, P, h);
    };
  }, [u, s, h]);
}
function Je(u) {
  const l = Ze(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return dt(() => {
    l.current = u;
  }, [u]), se((...s) => {
    var h;
    return (h = l.current) == null ? void 0 : h.call(l, ...s);
  }, [l]);
}
var Ae = typeof window > "u";
function er(u, l, s = {}) {
  const { initializeWithValue: h = !0 } = s, E = se(
    (a) => s.serializer ? s.serializer(a) : JSON.stringify(a),
    [s]
  ), g = se(
    (a) => {
      if (s.deserializer)
        return s.deserializer(a);
      if (a === "undefined")
        return;
      const d = l instanceof Function ? l() : l;
      let f;
      try {
        f = JSON.parse(a);
      } catch (p) {
        return console.error("Error parsing JSON:", p), d;
      }
      return f;
    },
    [s, l]
  ), P = se(() => {
    const a = l instanceof Function ? l() : l;
    if (Ae)
      return a;
    try {
      const d = window.sessionStorage.getItem(u);
      return d ? g(d) : a;
    } catch (d) {
      return console.warn(`Error reading sessionStorage key “${u}”:`, d), a;
    }
  }, [l, u, g]), [w, t] = qe(() => h ? P() : l instanceof Function ? l() : l), n = Je((a) => {
    Ae && console.warn(
      `Tried setting sessionStorage key “${u}” even though environment is not a client`
    );
    try {
      const d = a instanceof Function ? a(P()) : a;
      window.sessionStorage.setItem(u, E(d)), t(d), window.dispatchEvent(new StorageEvent("session-storage", { key: u }));
    } catch (d) {
      console.warn(`Error setting sessionStorage key “${u}”:`, d);
    }
  }), r = Je(() => {
    Ae && console.warn(
      `Tried removing sessionStorage key “${u}” even though environment is not a client`
    );
    const a = l instanceof Function ? l() : l;
    window.sessionStorage.removeItem(u), t(a), window.dispatchEvent(new StorageEvent("session-storage", { key: u }));
  });
  pe(() => {
    t(P());
  }, [u]);
  const o = se(
    (a) => {
      a.key && a.key !== u || t(P());
    },
    [u, P]
  );
  return Xe("storage", o), Xe("session-storage", o), [w, n, r];
}
const or = ({
  receiverId: u,
  size: l = 100,
  photoIdent: s = "",
  onImageUploaded: h,
  pollingInterval: E = 2e3,
  // Default 2 seconds
  apiKey: g,
  params: P,
  logo: w,
  logoSize: t = l * 0.2,
  // Default logo size is 20% of QR code size
  logoBackgroundColor: n = "#FFFFFF",
  logoOpacity: r = 1
}) => {
  const [o, a] = qe(!0), d = `photoClient_${u}_${s}`, [f, p] = er(
    d,
    []
  ), v = {
    ...P || {},
    photoIdent: s
  }, I = () => {
    const S = `https://scripts.create2stay.com/photo?r=${u}`, A = new URLSearchParams();
    Object.entries(v).forEach(([k, F]) => {
      F != null && A.append(k, F.toString());
    });
    const j = A.toString();
    return j ? `${S}&${j}` : S;
  }, C = (S, A) => {
    if (S.length !== A.length)
      return !0;
    const j = new Map(A.map((k) => [k.id, k]));
    return S.some((k) => {
      const F = j.get(k.id);
      return F ? k.url !== F.url || k.result.status !== F.result.status || k.result.data.imageId !== F.result.data.imageId || k.result.data.success !== F.result.data.success : !0;
    });
  }, R = async () => {
    try {
      const S = new URL("https://create2stay-functions2.azurewebsites.net/api/photo/list");
      S.searchParams.append("r", u), Object.entries(v).forEach(([k, F]) => {
        F != null && S.searchParams.append(k, F.toString());
      });
      const A = await fetch(S.toString(), {
        method: "GET",
        headers: {
          "x-functions-key": g
        },
        mode: "cors"
      });
      if (!A.ok)
        throw new Error(`HTTP error! status: ${A.status}`);
      const j = await A.json();
      j && j.length > 0 && C(j, f) && (h == null || h(j), p(j));
    } catch (S) {
      console.error("Error fetching photos:", S);
    }
  };
  return pe(() => {
    if (!o)
      return;
    const S = setInterval(R, E);
    return R(), () => {
      clearInterval(S);
    };
  }, [o, u, s, E, g]), /* @__PURE__ */ Bt.jsx(
    ft,
    {
      value: I(),
      size: l,
      level: "H",
      imageSettings: w ? {
        src: w,
        height: t,
        width: t,
        excavate: !0,
        opacity: r
      } : void 0,
      bgColor: n
    }
  );
};
export {
  or as PhotoClient
};
